import { render, staticRenderFns } from "./ExceptionWithImg.vue?vue&type=template&id=4d81e29b&scoped=true&"
import script from "./ExceptionWithImg.vue?vue&type=script&lang=js&"
export * from "./ExceptionWithImg.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionWithImg.vue?vue&type=style&index=0&id=4d81e29b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d81e29b",
  null
  
)

export default component.exports